import { useMemo } from 'react';
import {
  useSubjectMeta,
  useEngineInstance,
  useSubjectId,
  UseSubjectMetaSelector,
  Equality
} from '@surveycake/react-logic-engine';

interface MetaResult {
  visible: boolean;
  enable: boolean;
}

const metaSelector: UseSubjectMetaSelector<MetaResult> = ({
  visible,
  enable
}) => ({
  visible,
  enable
});

const metaEquality: Equality<MetaResult> = (prev, next) =>
  prev.enable === next.enable && prev.visible === next.visible;

export function useSubjectContainer() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { type, indent, hasTimer, singleSubjectPerPage } = useMemo(() => {
    const data = engine.getSubjectData(id);
    return {
      type: data.type,
      indent: data.indent,
      hasTimer: typeof data.timer === 'number',
      singleSubjectPerPage: engine.isSingleSubjectPerPage()
    };
  }, [engine, id]);
  const { visible, enable } = useSubjectMeta(id, metaSelector, metaEquality);

  return {
    id,
    type,
    indent,
    hasTimer,
    visible,
    enable,
    singleSubjectPerPage
  };
}
